import { render } from "./InnerLoader.vue?vue&type=template&id=f1af0fb6&scoped=true"
import script from "./InnerLoader.vue?vue&type=script&lang=js"
export * from "./InnerLoader.vue?vue&type=script&lang=js"

import "./InnerLoader.vue?vue&type=style&index=0&id=f1af0fb6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1af0fb6"]])

export default __exports__